import styled from 'styled-components';
import { screenSize, colors, fontSizes, fontWeight } from 'styleGuide';

export const StyledFooter = styled.footer`
  position: relative;
  color: ${colors.gray.dark};
  padding: 40px 20px 40px 20px;
  @media (max-width: ${screenSize.mobileL}) {
    font-size: ${fontSizes.sm};
    padding: 0;
  }
`;

export const LinkLogo = styled.a`
  color: ${colors.blue.primary};
  @media (max-width: 576px) {
    width: 70%;
  }
`;

export const FooterLink = styled.a`
  color: ${colors.gray.dark};
  font-size: ${fontSizes.base};
  line-height: 30px;
  &[role='button']:hover {
    color: ${colors.blue.secondary};
    cursor: pointer;
  }
  @media (max-width: ${screenSize.mobileL}) {
    font-size: ${fontSizes.sm};
  }
`;

export const FooterTitle = styled.span`
  font-weight: ${fontWeight.fontHeavy};
  text-transform: initial;
`;

export const SubFooter = styled.div`
  background-color: ${colors.white};
  padding-bottom: 40px;
  color: ${colors.blue.primary};
  font-size: ${fontSizes.sm};
  a {
    padding: 0 6px;
  }
`;

export const StyledHR = styled.hr`
  margin-right: 8%;
  margin-left: 8%;
  border-width: 2px;
  color: #dadbdd;
  @media (max-width: ${screenSize.mobileL}) {
    margin-top: 2rem;
  }
`;
